import { useMutation } from '@tanstack/react-query';
import { getReqUrl, handleDataPlatformError } from '../utils';
import { DROPS_ENDPOINT } from './constants';
import dataPlatformFetch from '../../../utils/dataPlatformFetch';

export const useMakeReservation = () => {
  return useMutation(async (variables) => {
    const url = getReqUrl(DROPS_ENDPOINT, `/${variables.dropId}/reserve`);
    const res = await dataPlatformFetch(url, {
      method: 'POST',
      recaptchaToken: variables.recaptchaToken
    });
    if (!res.ok) {
      await handleDataPlatformError(res);
    }
    const responseJson = await res.json();
    responseJson.headers = res.headers;
    return responseJson;
  });
};
